"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AddressForm = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _fields = require("../../form/fields");
var _formActions = require("../../redux/actions/form/formActions");
var _Form = _interopRequireDefault(require("../form/Form"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var isNonProd = function isNonProd() {
  var isClient = typeof window !== 'undefined';
  var env = isClient && (0, _get["default"])(window, 'env.ENV');
  return isClient && (env === 'local' || env === 'dev' || env === 'test');
};
var AddressForm = exports.AddressForm = /*#__PURE__*/function (_Component) {
  function AddressForm(props) {
    var _this;
    _classCallCheck(this, AddressForm);
    _this = _callSuper(this, AddressForm, [props]);
    _defineProperty(_this, "onAddAddressLine", function () {
      var maxAddressLines = _this.props.maxAddressLines;
      var addressLines = _this.state.addressLines;
      var newAddressLines = addressLines < maxAddressLines ? addressLines + 1 : addressLines;
      _this.updateFormConfig({
        addressLines: newAddressLines
      });
    });
    _defineProperty(_this, "updateFormConfig", function (_ref) {
      var _ref$countryCode = _ref.countryCode,
        countryCode = _ref$countryCode === void 0 ? _this.props.countryCode : _ref$countryCode,
        newAddressLines = _ref.addressLines,
        _ref$postcodeSearchFo = _ref.postcodeSearchFormVisible,
        postcodeSearchFormVisible = _ref$postcodeSearchFo === void 0 ? _this.props.postcodeSearchFormVisible : _ref$postcodeSearchFo,
        _ref$configExtras = _ref.configExtras,
        configExtras = _ref$configExtras === void 0 ? _this.props.configExtras : _ref$configExtras,
        _ref$internationalMod = _ref.internationalMode,
        internationalMode = _ref$internationalMod === void 0 ? _this.props.internationalMode : _ref$internationalMod;
      var _this$props = _this.props,
        getConfig = _this$props.getConfig,
        regionCode = _this$props.regionCode;
      if (getConfig) {
        var _this$props2 = _this.props,
          international = _this$props2.international,
          maxAddressLines = _this$props2.maxAddressLines,
          onSearchForAnotherAddress = _this$props2.onSearchForAnotherAddress,
          onSearchUKPostcode = _this$props2.onSearchUKPostcode;
        var currentAddressLines = _this.state.addressLines;
        var addressLines = newAddressLines || currentAddressLines;
        var config = getConfig({
          international: international,
          internationalMode: internationalMode,
          countryCode: countryCode,
          regionCode: regionCode,
          addressLines: addressLines,
          maxAddressLines: maxAddressLines,
          actions: {
            addAddressLine: _this.onAddAddressLine,
            searchForAnotherAddress: onSearchForAnotherAddress,
            searchUKPostcode: onSearchUKPostcode
          },
          configExtras: configExtras,
          postcodeSearchFormVisible: postcodeSearchFormVisible
        });
        _this.setState({
          addressLines: addressLines,
          config: config
        });
      }
    });
    var _getConfig = _this.props.getConfig;
    if (_getConfig) {
      var _this$props3 = _this.props,
        international = _this$props3.international,
        internationalMode = _this$props3.internationalMode,
        initialValues = _this$props3.initialValues,
        initialAddressLines = _this$props3.initialAddressLines,
        maxAddressLines = _this$props3.maxAddressLines,
        onSearchForAnotherAddress = _this$props3.onSearchForAnotherAddress,
        onSearchUKPostcode = _this$props3.onSearchUKPostcode,
        configExtras = _this$props3.configExtras,
        postcodeSearchFormVisible = _this$props3.postcodeSearchFormVisible,
        formValues = _this$props3.formValues,
        regionCode = _this$props3.regionCode,
        countryCode = _this$props3.countryCode;
      var combinedValues = _objectSpread(_objectSpread({}, initialValues), formValues);
      var addressLines = AddressForm.calcAddressLinesFromFormValues(combinedValues, initialAddressLines);
      _this.state = {
        addressLines: addressLines,
        config: _getConfig({
          international: international,
          internationalMode: internationalMode,
          countryCode: countryCode,
          regionCode: regionCode,
          addressLines: addressLines,
          maxAddressLines: maxAddressLines,
          actions: {
            addAddressLine: _this.onAddAddressLine,
            searchForAnotherAddress: onSearchForAnotherAddress,
            searchUKPostcode: onSearchUKPostcode
          },
          configExtras: configExtras,
          postcodeSearchFormVisible: postcodeSearchFormVisible
        })
      };
    }
    return _this;
  }
  _inherits(AddressForm, _Component);
  return _createClass(AddressForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var config = this.state.config;
      var _this$props4 = this.props,
        initialValues = _this$props4.initialValues,
        formValues = _this$props4.formValues,
        resetForm = _this$props4.resetForm,
        showErrorsOnInit = _this$props4.showErrorsOnInit;
      var initValues = _objectSpread(_objectSpread({}, initialValues), formValues);

      // console.warn('MOUNT reset', initValues, showErrorsOnInit);
      resetForm(config.id, initValues, showErrorsOnInit);
    }

    // https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/222
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var initialValues = nextProps.initialValues,
        countryCode = nextProps.countryCode,
        formValues = nextProps.formValues,
        initialAddressLines = nextProps.initialAddressLines,
        postcodeSearchFormVisible = nextProps.postcodeSearchFormVisible,
        configExtras = nextProps.configExtras,
        internationalMode = nextProps.internationalMode;

      // special condition for use with autofill widget in local/dev/test environments
      if (isNonProd()) {
        var formValuesAddressLinesNumber = AddressForm.calcAddressLinesFromFormValues(this.props.formValues, initialAddressLines);
        var nextFormValuesAddressLinesNumber = AddressForm.calcAddressLinesFromFormValues(formValues, initialAddressLines);
        if (formValuesAddressLinesNumber !== nextFormValuesAddressLinesNumber) {
          this.updateFormConfig({
            countryCode: countryCode,
            addressLines: nextFormValuesAddressLinesNumber,
            postcodeSearchFormVisible: postcodeSearchFormVisible,
            configExtras: configExtras,
            internationalMode: internationalMode
          });
          return;
        }
      }
      var initialValuesChanged = !(0, _isEqual["default"])(this.props.initialValues, initialValues);

      // after new address search...
      if (initialValuesChanged) {
        var _addressLines = AddressForm.calcAddressLinesFromFormValues(initialValues, initialAddressLines);
        this.updateFormConfig({
          countryCode: countryCode,
          addressLines: _addressLines,
          postcodeSearchFormVisible: postcodeSearchFormVisible,
          configExtras: configExtras,
          internationalMode: internationalMode
        });
        return;
      }
      var addressLines = this.state.addressLines;
      this.updateFormConfig({
        countryCode: countryCode,
        addressLines: addressLines,
        postcodeSearchFormVisible: postcodeSearchFormVisible,
        configExtras: configExtras,
        internationalMode: internationalMode
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props5 = this.props,
        resetForm = _this$props5.resetForm,
        countryCode = _this$props5.countryCode,
        formValues = _this$props5.formValues,
        initialValues = _this$props5.initialValues,
        showErrorsOnInit = _this$props5.showErrorsOnInit;
      var config = this.state.config;
      var title = formValues.title,
        firstName = formValues.firstName,
        lastName = formValues.lastName,
        phoneNumber = formValues.phoneNumber,
        phoneNumberCountryCode = formValues.phoneNumberCountryCode,
        id = formValues.id;
      if (config) {
        // if country selector is used... reset form but maintain name and phone number details
        if (prevProps.countryCode && prevProps.countryCode !== countryCode) {
          // console.warn('>>>>>> AddressForm UPDATE RESETTING countryCode changed');
          var initValues = {
            title: title,
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber,
            phoneNumberCountryCode: phoneNumberCountryCode,
            countryCode: countryCode
          };
          if (id) {
            initValues.id = id;
          }
          resetForm(config.id, initValues, showErrorsOnInit, true);
          return;
        }

        // if form is re-initialised... reset form but maintain name and phone number details
        if (!(0, _isEqual["default"])(prevProps.initialValues, initialValues)) {
          // console.warn('>>>>>> AddressForm UPDATE RESETTING initValues changed', prevProps.initialValues, initialValues);
          var _initValues = _objectSpread(_objectSpread({}, initialValues), {}, {
            title: title,
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber,
            phoneNumberCountryCode: phoneNumberCountryCode
          });
          if (id) {
            _initValues.id = id;
          }
          resetForm(config.id, _initValues, showErrorsOnInit, true);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        onFormSubmit = _this$props6.onFormSubmit,
        onFormSubmitFailed = _this$props6.onFormSubmitFailed,
        destroyOnUnmount = _this$props6.destroyOnUnmount,
        useFormValidationErrorsAlertMessage = _this$props6.useFormValidationErrorsAlertMessage,
        postcodeSearchFormVisible = _this$props6.postcodeSearchFormVisible,
        internationalMode = _this$props6.internationalMode,
        countryCode = _this$props6.countryCode,
        disabled = _this$props6.disabled,
        dataTestId = _this$props6['data-testid'],
        multiFormValidation = _this$props6.multiFormValidation,
        formValues = _this$props6.formValues,
        touchOnChange = _this$props6.touchOnChange,
        scrollValidationMessageIntoView = _this$props6.scrollValidationMessageIntoView;
      var config = this.state.config;
      if (!(0, _get["default"])(config, 'fields.length')) {
        return null;
      }
      var hideSubmitButton = internationalMode ? !countryCode : postcodeSearchFormVisible;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Form["default"], {
        "data-testid": dataTestId,
        config: config,
        form: config.id,
        onSubmit: onFormSubmit,
        onSubmitFailed: onFormSubmitFailed,
        destroyOnUnmount: destroyOnUnmount,
        useFormValidationErrorsAlertMessage: useFormValidationErrorsAlertMessage,
        hideSubmitButton: hideSubmitButton,
        disabled: disabled,
        multiFormValidation: multiFormValidation,
        initialValues: formValues,
        touchOnChange: touchOnChange,
        "data-jlds": true,
        scrollValidationMessageIntoView: scrollValidationMessageIntoView
      });
    }
  }]);
}(_react.Component);
_defineProperty(AddressForm, "propTypes", {
  getConfig: _propTypes["default"].func.isRequired,
  international: _propTypes["default"].bool,
  internationalMode: _propTypes["default"].bool,
  regionCode: _propTypes["default"].string,
  countryCode: _propTypes["default"].string,
  formValues: _propTypes["default"].objectOf(_propTypes["default"].string),
  initialValues: _propTypes["default"].objectOf(_propTypes["default"].string),
  initialAddressLines: _propTypes["default"].number,
  maxAddressLines: _propTypes["default"].number,
  destroyOnUnmount: _propTypes["default"].bool,
  useFormValidationErrorsAlertMessage: _propTypes["default"].bool,
  configExtras: _propTypes["default"].objectOf(_propTypes["default"].any),
  postcodeSearchFormVisible: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  dataTestId: _propTypes["default"].string,
  multiFormValidation: _propTypes["default"].bool,
  showErrorsOnInit: _propTypes["default"].bool,
  touchOnChange: _propTypes["default"].bool,
  onSearchForAnotherAddress: _propTypes["default"].func,
  onSearchUKPostcode: _propTypes["default"].func,
  onFormSubmit: _propTypes["default"].func,
  onFormSubmitFailed: _propTypes["default"].func,
  resetForm: _propTypes["default"].func,
  scrollValidationMessageIntoView: _propTypes["default"].bool
});
_defineProperty(AddressForm, "defaultProps", {
  getConfig: function getConfig() {},
  international: false,
  internationalMode: false,
  regionCode: '',
  countryCode: '',
  formValues: {},
  initialValues: {},
  initialAddressLines: 2,
  maxAddressLines: 4,
  destroyOnUnmount: false,
  useFormValidationErrorsAlertMessage: true,
  configExtras: {},
  postcodeSearchFormVisible: true,
  dataTestId: '',
  disabled: false,
  multiFormValidation: false,
  showErrorsOnInit: false,
  touchOnChange: false,
  onSearchForAnotherAddress: undefined,
  onSearchUKPostcode: undefined,
  onFormSubmit: undefined,
  onFormSubmitFailed: undefined,
  resetForm: function resetForm() {},
  scrollValidationMessageIntoView: false
});
_defineProperty(AddressForm, "calcAddressLinesFromFormValues", function (formValues, defaultAddressLines) {
  var valuesAddressLines = Object.keys(formValues).reduce(function (acc, key) {
    if (key.indexOf('addressLine') !== -1) {
      var number = parseInt(key.replace(/[^0-9]/g, ''), 10);
      return number > acc ? number : acc;
    }
    return acc;
  }, 0);
  return valuesAddressLines > defaultAddressLines ? valuesAddressLines : defaultAddressLines;
});
var _default = exports["default"] = (0, _reactRedux.connect)(function (state, ownProps) {
  var formId = ownProps.formId;
  var formValues = (0, _get["default"])(state.form, "".concat(formId, ".values"), {});
  return {
    countryCode: formValues[_fields.COUNTRY_SELECTOR.name] || (0, _get["default"])(ownProps.initialValues, _fields.COUNTRY_SELECTOR.name),
    formValues: formValues,
    regionCode: ownProps.regionCode || ''
  };
}, {
  resetForm: _formActions.resetForm
})(AddressForm);